<!-- 疾病危険度カード -->
<template>
  <div class="card--container">
    <span @click.capture="preventRouting">
      <router-link
        class="link-to-discription"
        :to="{ name: 'report-discription', params: { index: disease } }"
      >
        <div class="card--content">
          <panel
            class="card--content__panel"
            :riskIndex="risk_index"
            :diseaseHistory="diseaseHistory"
            :dataTest="disease"
          />
            <div
              v-text="convertDiseaseName"
              :style="{ color: textColor }"
              class="card--content__text__disease-name"
              :class="disease"
            />
            <value-with-unit
              v-if="!diseaseHistory"
              class="card-percent-text-font card-percent-font-position"
              :value="risk_rate | fixedPersentage"
              unit="%"
            />
        </div>
      </router-link>
    </span>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import Panel from "../../atoms/AIDiseasePredictionReport/Panel";
import ValueWithUnit from "../../molecules/AIDiseasePredictionReport/ValueWithUnit";
export default {
  props: {
    risk_index: VueTypes.number.isRequired,
    disease: VueTypes.string.isRequired,
    risk_rate: VueTypes.number.isRequired,
    index: VueTypes.number.index
  },
  components: {
    Panel,
    ValueWithUnit
  },
  computed: {
    convertDiseaseName() {
      return this.$store.state.labels.diseaseNames[this.disease];
    },
    textColor() {
      if (this.diseaseHistory) {
        return "#CCCCCC";
      }
      switch (this.risk_index) {
        case 0:
          return "#95BE91";
        case 1:
          return "#EAC75C";
        case 2:
          return "#DEB081";
        case 3:
          return "#CE7D8D";
      }
    },
    diseaseHistory() {
      return this.$store.getters["selvy/getModel"][this.disease];
    }
  },
  filters: {
    fixedPersentage: function(value) {
      let val = Math.floor(value);
      if (val === 0) {
        return 1;
      } else if (val === 100) {
        return 99;
      } else {
        return val;
      }
    }
  },
  methods: {
    preventRouting(e) {
      if (this.diseaseHistory) {
        e.preventDefault();
      }
    }
  }
};
</script>

<style scoped>
.card--container {
  width: 100%;
}
.card--content {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  z-index: -1;
}
.card--content__panel {
  width: 145px;
  height: auto;
}
.card--content__text__disease-name {
  font-size: 18px;
  font-weight: bold;
  position: absolute;
  top: 85px;
  left: 45%;
  transform: translate(-50%, 0);
  width: 100%;
}
.card-percent-text-font {
  color: white;
  font-weight: bold;
  position: absolute;
  top: 115px;
  left: 50px;
}
.card-percent-text-font >>> .value {
  font-size: 26px;
}
.card-percent-text-font >>> .unit {
  font-size: 24px;
}
/** スマホ */
@media screen and (max-width: 599px) {
  .card--content__panel {
    width: 80px;
  }
  .card--content__text__disease-name {
    font-size: 14px;
    top: 46px;
    left: 40px;
  }
  .card-percent-font-position {
    top: 62px;
    left: 40%;
    transform: translate(-40%, 0);
  }
  .card-percent-text-font >>> .value {
    font-size: 16px;
  }
  .card-percent-text-font >>> .unit {
    font-size: 14px;
  }
}
/** タブレット */
@media screen and (min-width: 600px) and (max-width: 959px) {
  .card--content__panel {
    width: 100px;
    height: auto;
  }
  .card--content__text__disease-name {
    font-size: 16px;
    top: 57px;
    left: 50%;
    transform: translate(-55%, 0);
  }
  .card-percent-font-position {
    top: 80px;
    left: 50%;
    transform: translate(-60%, 0);
  }
  .card-percent-text-font >>> .value {
    font-size: 18px;
  }
  .card-percent-text-font >>> .unit {
    font-size: 16px;
  }
}
.link-to-discription:hover {
  text-decoration: none;
}
</style>
